import { useState } from "react";

const useHandleForm = (data, createCallback, modifyCallback, invalidDataCallback) => {

    const isCreate = !Boolean(data);

    const createInitialData = () => {

        const getInitialFieldData = (fieldName) => {
            return (isCreate || !data[fieldName]) ? "" : data[fieldName];
        }

        const fieldNames = [
            'text',
            'htmlText',
        ];

        return fieldNames.reduce((initialData, fieldName) => {
            return ({
                ...initialData,
                [fieldName]: getInitialFieldData(fieldName)
            })
        }, {});
    }

    const [formData, setFormData] = useState(createInitialData());

    const dataIsValid = () => {
        return Boolean(formData.text);
    }

    const submit = () => {
        if (dataIsValid()) {
            isCreate ? createCallback(formData) : modifyCallback({ internalCode: data.internalCode, ...formData });
            return true;
        } else {
            invalidDataCallback();
            return false;
        }
    }

    const setFormValue = (value, fieldName) => {
        setFormData({
            ...formData,
            text: value.text,
            htmlText: value.htmlText,
        })
    }

    return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;
